const labels = {
    'administracao_publica' : 'Administração Pública',
    'agricultura' : 'Agricultura',
    'agua_esgoto_residuos' : 'Água, Esgoto e Resíduos',
    'alojamento_alimentacao' : 'Alojamento e Alimentação',
    'ano' : 'Ano',
    'ano_calculo_vl_potencial_consumo' : 'Ano de cálculo do valor potencial de consumo',
    'ano_pof_referencia' : 'Ano de referência da POF',
    'area' : 'Área',
    'area_km2' : 'Área (km²)',
    'area_total_km2' : 'Área Total (km²)',
    'artes_recreacao' : 'Artes e Recreação',
    'atividades_administrativas' : 'Atividades Administrativas',
    'atividades_financeiras' : 'Atividades Financeiras',
    'atividades_imobiliarias' : 'Atividades Imobiliárias',
    'atividades_profissionais_cien_tec' : 'Atividades Profissionais, Científicas e Técnicas',
    'categoria' : 'Categoria',
    'cd_setor' : 'Código do Setor',
    'classe_renda_pof' : 'Classe de renda da POF',
    'classe_taxa_domicilios_2010_2022' : 'Classe da Taxa de Domicílios 2010-2022',
    'comercio_veiculos' : 'Comércio de Veículos',
    'construcao' : 'Construção',
    'crescimento_percentual' : 'Crescimento Percentual',
    'distribuidora' : 'Distribuidora',
    'domic_part_alugado_v008' : 'Domicílios - Alugado',
    'domic_part_cedido_outro_v010' : 'Domicílios Cedidos Outro',
    'domic_part_cedido_por_empregador_v009' : 'Domicílios Cedidos por Empregador',
    'domic_part_outra_condicao_v011' : 'Domicílios Outra Condição',
    'domic_part_proprio_em_aquisicao_v007' : 'Domicílios - Próprio em Aquisição',
    'domic_part_proprio_quitado_v006' : 'Domicílios - Próprio Quitado',
    'dt_upload' : 'Data de upload',
    'educacao' : 'Educação',
    'eletricidade_gas' : 'Eletricidade e Gás',
    'faixa_renda_pof_2025' : 'Faixa de renda da POF 2025',
    'fonte' : 'Fonte',
    'gid_municipio' : 'ID do município',
    'gid_uf' : 'ID da UF',
    'idhm' : 'IDHM',
    'industrias_extrativas' : 'Indústrias Extrativas',
    'industrias_transformacao' : 'Indústrias de Transformação',
    'informacao_comunicacao' : 'Informação e Comunicação',
    'nm_municipio' : 'Nome do Município',
    'nome' : 'Nome',
    'nome_dutovia' : 'Nome da Dutovia',
    'nr_densidade_demografica_hab_km2': 'Densidade Demográfica (hab/km²)',
    'nr_dom_part_perm_ocupados_apartamento_v00049' : 'Domicílios por tipo: Apartamento',
    'nr_dom_part_perm_ocupados_casa_v00047' : 'Domicílios por tipo: Casa',
    'nr_dom_part_perm_ocupados_vila_cond_v00048' : 'Domicílios por tipo: Condomínio ou Vila',
    'nr_dom_part_perm_ocupados_outros_tipos_v00050_51_52' : 'Domicílios por tipo: Outros Tipos',
    'nr_domicilios_censo2000' : 'Domicílios 2000',
    'nr_domicilios_censo2010' : 'Domicílios 2010',
    'nr_domicilios_censo2022' : 'Domicílios 2022',
    'nr_domicilios_particulares_ocupados_alugado' : 'Domicílios - Alugado',
    'nr_domicilios_particulares_ocupados_cedido_ou_emprestado' : 'Domicílios - Cedido ou Emprestado',
    'nr_domicilios_particulares_ocupados_outras_condicoes' : 'Domicílios - Outras Condições',
    'nr_domicilios_particulares_ocupados_proprio_financiado' : 'Domicílios - Próprio Financiado',
    'nr_domicilios_particulares_ocupados_proprio_quitado' : 'Domicílios - Próprio Quitado',
    'nr_domicilios_particulares_ocupados_v0007' : 'Domicílios Ocupados',
    'nr_domicilios_particulares_v0003' : 'Domicílios Total',
    'nr_domicilios_particulares_vagos' : 'Domicílios Vagos',
    'nr_pessoas_2022_v0001' : 'População 2022',
    'nr_pessoas_proj_2026' : 'População 2026',
    'nr_populacao_0_4_anos_v01031' : 'População 0 a 4 Anos',
    'nr_populacao_10_14_anos_v01033' : 'População 10 a 14 Anos',
    'nr_populacao_15_19_anos_v01034' : 'População 15 a 19 Anos',
    'nr_populacao_20_24_anos_v01035' : 'População 20 a 24 Anos',
    'nr_populacao_25_29_anos_v01036' : 'População 25 a 29 Anos',
    'nr_populacao_30_39_anos_v01037' : 'População 30 a 39 Anos',
    'nr_populacao_40_49_anos_v01038' : 'População 40 a 49 Anos',
    'nr_populacao_50_59_anos_v01039' : 'População 50 a 59 Anos',
    'nr_populacao_5_9_anos_v01032' : 'População 5 a 9 Anos',
    'nr_populacao_60_69_anos_v01040' : 'População 60 a 69 Anos',
    'nr_populacao_70_anos_mais_v01041' : 'População 70 Anos ou Mais',
    'nr_populacao_censo2000' : 'População 2000',
    'nr_populacao_censo2010' : 'População 2010',
    'nr_populacao_censo2022' : 'População 2022' ,
    'nr_salario_minimo_mensal_por_domicilio' : 'Renda Média Domiciliar - em salários mínimos',
    'org_internacionais' : 'Organizações Internacionais',
    'outros' : 'Outros',
    'pib' : 'PIB Total',
    'pib_per_capita' : 'PIB per Capita',
    'rend_mensal_por_domicilio2026' : 'Renda Média Domiciliar',
    'saude_servicos_sociais' : 'Saúde e Serviços Sociais',
    'servicos_domesticos' : 'Serviços Domésticos',
    'sigla_uf' : 'Sigla da UF',
    'taxa_administracao_publica' : 'Taxa de Administração Pública',
    'taxa_agricultura' : 'Taxa de Agricultura',
    'taxa_agua_esgoto_residuos' : 'Taxa de Água, Esgoto e Resíduos',
    'taxa_alojamento_alimentacao' : 'Taxa de Alojamento e Alimentação',
    'taxa_artes_recreacao' : 'Taxa de Artes e Recreação',
    'taxa_atividades_administrativas' : 'Taxa de Atividades Administrativas',
    'taxa_atividades_financeiras' : 'Taxa de Atividades Financeiras',
    'taxa_atividades_imobiliarias' : 'Taxa de Atividades Imobiliárias',
    'taxa_atividades_profissionais_cien_tec' : 'Taxa de Atividades Profissionais, Científicas e Técnicas',
    'taxa_comercio_veiculos' : 'Taxa de Comércio de Veículos',
    'taxa_construcao' : 'Taxa de Construção',
    'taxa_domicilios_2010_2022' : 'Taxa Crescimento Domiciliar 2010-2022',
    'taxa_educacao' : 'Taxa de Educação',
    'taxa_eletrecidade_gas' : 'Taxa de Eletricidade e Gás',
    'taxa_industrias_extrativas' : 'Taxa de Indústrias Extrativas',
    'taxa_industrias_transformacao' : 'Taxa de Indústrias de Transformação',
    'taxa_informacao_comunicacao' : 'Taxa de Informação e Comunicação',
    'taxa_org_internacionais' : 'Taxa de Organizações Internacionais',
    'taxa_outros' : 'Taxa de Outros',
    'taxa_saude_servicos_sociais' : 'Taxa de Saúde e Serviços Sociais',
    'taxa_servicos_domesticos' : 'Taxa de Serviços Domésticos',
    'taxa_transporte_armazenagem' : 'Taxa de Transporte e Armazenagem',
    'tipo' : 'Tipo',
    'tipo_dutovia' : 'Tipo de Dutovia',
    'total' : 'Total',
    'transporte_armazenagem' : 'Transporte e Armazenagem',
    'tx_alimentacao' : 'Alimentação (%)',
    'tx_alimentacao_bebidas' : 'Bebidas (%)',
    'tx_alimentacao_dentro' : 'Alimentação no Domicílio (%)',
    'tx_alimentacao_fora' : 'Alimentação fora do Domicílio (%)',
    'tx_artigos_limpeza' : 'Artigos de Limpeza (%)',
    'tx_aumento_do_ativo' : 'Taxa de aumento do ativo (%)',
    'tx_calcados' : 'Calçados (%)',
    'tx_despesas_consumo' : 'Potencial de Consumo Total (%)',
    'tx_despesas_viagens' : 'Viagens (%)',
    'tx_educacao' : 'Educação (%)',
    'tx_eletrodomesticos' : 'Eletrodomésticos e Equip. (%)',
    'tx_gastos_medicamentos' : 'Medicamentos (%)',
    'tx_habitacao' : 'Habitação (%)',
    'tx_higiene_cuidados_pessoais' : 'Higiene e Cuidados Pessoais (%)',
    'tx_indice_propriedade' : 'Indíce de Propriedade',
    'tx_livros_material_escolar' : 'Livros e Material Escolar (%)',
    'tx_material_construcao' : 'Material de Construção (%)' ,
    'tx_matriculas_mensalidades' : 'Matrículas e Mensalidades (%)',
    'tx_mobiliarios_artigos_lar' : 'Mobiliários e Artigos de Lar (%)',
    'tx_outras_despesas_saude' : 'Outras Despesas com Saúde (%)',
    'tx_pessoas_domicilios' : 'População por Domicílios',
    'tx_recreacao_e_cultura' : 'Recreação e Cultura (%)',
    'tx_saude' : 'Saúde (%)',
    'tx_vestuario' : 'Vestuário (%)',

    'vl_alimentacao' : 'Alimentação (R$)',
    'vl_alimentacao_bebidas' : 'Bebidas (R$)',
    'vl_alimentacao_dentro' : 'Alimentação no Domicílio (R$)',
    'vl_alimentacao_fora' : 'Alimentação Fora Domicílio (R$)',
    'vl_artigos_limpeza' : 'Artigos de Limpeza (R$)',
    'vl_aumento_do_ativo' : 'Valor de aumento do ativo (R$)',
    'vl_calcados' : 'Calçados (R$)',

    'vl_despesas_consumo' : 'Potencial de consumo total (R$)',
    'vl_despesas_viagens' : 'Viagens (R$)',

    'vl_educacao' : 'Educação (R$)',
    'vl_eletrodomesticos' : 'Eletrodomésticos e Equip. (R$)',
    'vl_gastos_medicamentos' : 'Medicamentos (R$)',
    'vl_habitacao' : 'Habitação (R$)',
    'vl_higiene_cuidados_pessoais' : 'Higiene e Cuidados Pessoais (R$)',
    'vl_livros_material_escolar' : 'Livros e Material Escolar (R$)',
    'vl_material_construcao' : 'Material de Construção (R$)',
    'vl_matriculas_mensalidades' : 'Matrículas e Mensalidades (R$)',
    'vl_mobiliarios_artigos_lar' : 'Mobiliários e Artigos de Lar (R$)',
    'vl_outras_despesas_saude' : 'Outras Despesas com Saúde (R$)',
    'vl_recreacao_e_cultura' : 'Recreação e Cultura (R$)',
    'vl_saude' : 'Saúde (R$)',
    'vl_vestuario' : 'Vestuário (R$)',
    'renda' : 'Renda',
    'populacao' : 'População',
    'domicilios' : 'Domicílios',
    'indice_verticalizacao' : 'Índice de Verticalização',
    'tx_investimento_em_imovel' : 'Investimento em Imóvel (%)',
    'tx_acessorios_de_moda' : 'Acessórios de Moda (%)',
    'tx_servicos_pessoais' : 'Serviços pessoais (%)',
    'total_despesas_consumo' : 'Despesas de Consumo (R$)',
    'total_alimentacao_fora' : 'Total Alimentação fora do Domícilio (R$)',
    'total_alimentacao_dentro' : 'Total Alimentação no Domícilio (R$)',
    'total_habitacao' : 'Total Habitação (R$)',
    'total_material_construcao' : 'Total Material de Construção (R$)',
    'total_artigos_limpeza' : 'Total Artigos de Limpeza (R$)',
    'total_mobiliarios_artigos_lar' : 'Total Mobiliários e Artigos de Lar (R$)',
    'total_eletrodomesticos' : 'Total Eletrodomésticos e Equip. (R$)',
    'total_vestuario' : 'Total Vestuário (R$)',
    'total_calcados' : 'Total Calçados (R$)',
    'total_despesas_viagens' : 'Total Viagens (R$)',
    'total_higiene_cuidados_pessoais' : 'Total Higiene e Cuidados Pessoais (R$)',
    'total_matriculas_mensalidades' : 'Total Matrículas e Mensalidades (R$)',
    'total_livros_material_escolar' : 'Total Livros e Material Escolar (R$)',
    'total_gastos_medicamentos' : 'Total Medicamentos (R$)',
    'total_outras_despesas_saude' : 'Total Outras Despesas com Saúde (R$)',
    'total_recreacao_e_cultura' : 'Total Recreação e Cultura (R$)',
    'total_educacao' : 'Total Educação (R$)',
    'total_saude' : 'Total Saúde (R$)',
    'total_alimentacao_bebidas' : 'Total Bebidas (R$)',
    'vl_investimento_em_imovel' : 'Investimento em Imóvel (R$)',
    'total_investimento_em_imovel' : 'Total Investimento em Imóvel (R$)',
    'vl_acessorios_de_moda' : 'Acessórios de Moda (R$)',
    'total_acessorios_de_moda' : 'Total Acessórios de Moda (R$)',
    'total_servicos_pessoais' : 'Total Serviços pessoais (R$)',
    'vl_servicos_pessoais' : 'Serviços pessoais (R$)',
    'renda_media_domiciliar' : 'Renda Média Domiciliar (R$)',
}

export default (key) => {
    if (labels[key]) {
        return labels[key];
    } else {
        return key;
    }
}
